import { useSelector } from "react-redux";
import { RootState } from "toolkit/store";

const userUser = () => {
  const { user } = useSelector((state: RootState) => state.auth?.data) || {};
  return user;
};

export default userUser;
